import React from 'react';
import get from 'lodash/get';
export default ({ record, source, replace }) => {
    const value = get(record, source);
    const replacedValue = replace[value] ?? '';
    return (<>{replacedValue}</>);
}